"use strict";

const isTouchDevice = () => {
    return ("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
};

module.exports = {
    isTouchDevice: isTouchDevice
};
